export const WizardApiPath = 'wizard';
